<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <circle cx="9" cy="9" r="8.5" :stroke="color" />
      <path
        :fill="color"
        fill-rule="nonzero"
        d="M9 12c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zM9.193 11h-.502c-.208 0-.377-.188-.377-.42v-.013c0-2.462 2.43-2.227 2.43-3.76 0-.7-.557-1.407-1.802-1.407-.915 0-1.39.338-1.858 1.004-.123.175-.347.21-.51.083l-.412-.32c-.177-.137-.216-.412-.083-.601C6.745 4.613 7.535 4 8.942 4 10.584 4 12 5.041 12 6.807c0 2.36-2.43 2.235-2.43 3.76v.013c0 .232-.169.42-.377.42z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
